<template>
    <div class="testDialog">
        <h1>弹出dialog</h1>
        <iframe id="show-iframe"  frameborder=0 name="showHere" scrolling=auto :src="dialogHref"></iframe>
    </div>    
</template>
<script>
export default {
    name: 'testDialog',
    props:[
        'dialogHref'
    ]
}
</script>

<style lang="less">

</style>


// WEBPACK FOOTER //
// src/pages/websocketdialog/callDialog.vue